import type { Cartela, DrawEvent, Prize } from '../../shared/types';

export type LivePhase = 'idle' | 'wheel' | 'draw' | 'winner';

/** Estado da transmissão em curso. Um objeto mutável compartilhado pelo estúdio, roda e console. */
export interface LiveState {
  phase: LivePhase;
  event: DrawEvent | null;
  prize: Prize | null;
  pool: Cartela[];
  seed: string;
  hash: string;
  winner: Cartela | null;
  order: number[];
  step: number;
  digits: number;
  finalists: number;
  prevAlive: number;
  /** um dígito está rolando: bloqueia o botão principal */
  busy: boolean;
  /** respiro entre o último dígito travar e o ganhador aparecer */
  revealing: boolean;
  winTimer: number | undefined;
}

export const live: LiveState = {
  phase: 'idle', event: null, prize: null, pool: [], seed: '', hash: '', winner: null,
  order: [], step: 0, digits: 5, finalists: 1, prevAlive: 0, busy: false, revealing: false, winTimer: undefined
};
